import 'vite/modulepreload-polyfill'

import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import morph from '@alpinejs/morph'
import resize from '@alpinejs/resize'

import barba from '@barba/core'
import Alpine from 'alpinejs'

import useTransition from '~/utils/use-transition'
import { dolphin, fixatePageOnNavigation } from '~/utils/utils'
import cart from './components/cart'
import collection from './components/collection.js'
import collectionSamples from './components/collectionSamples'
import filter from './components/filter'
import footer from './components/footer'
import header from './components/header'
import loading from './components/loading.js'
import mainCollection from './components/mainCollection'
import newsletter from './components/newsletter.js'
import plp from './components/plp'
import productForm from './components/product-form'
import productRecommendations from './components/product-recommendations'
import productGallery from './components/productGallery'

Alpine.plugin(morph)
Alpine.plugin(resize)
Alpine.plugin(collapse)
Alpine.plugin(focus)

Alpine.store('isLoading', loading)
Alpine.store('cart', cart)

Alpine.data('header', header)
Alpine.data('productGallery', productGallery)
Alpine.data('collection', collection)
Alpine.data('footer', footer)
Alpine.data('filter', filter)
Alpine.data('plp', plp)
Alpine.data('productForm', productForm)
Alpine.data('productRecommendations', productRecommendations)
Alpine.data('collectionSamples', collectionSamples)
Alpine.data('newsletter', newsletter)
Alpine.data('mainCollection', mainCollection)
Alpine.magic('cart', () => Alpine.store('cart'))
Alpine.magic('loading', () => Alpine.store('isLoading'))

Alpine.magic('money', () => {
  const currency = window.Shopify.currency.active || 'USD'
  const locale = window.Shopify.locale || 'en-US'

  return amount => {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(amount)
  }
})

Alpine.start()

barba.init({
  debug: location.origin.includes('127.0.0.1'),
  prevent: () => window.Shopify.designMode,
  prefetchIgnore: '/cart',
  cacheIgnore: '/cart',
  transitions: useTransition({
    page: {
      default: {
        leave() {
          return
        },

        enter() {
          return
        },
      },
    },
    global: {
      before() {
        window.dispatchEvent(new CustomEvent('window.navigation'))
      },
    },
  }),
})

// place the old page "where it was" on navigation/scroll
fixatePageOnNavigation()

dolphin()

window.addEventListener('window.navigation', () => {
  Alpine.store('cart').toggle(false)
})


// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);